<template>
  <transition name="toast">
  <div
    v-if="visible"
    class="toast"
    :class="type"
    @click="removeToast"
  >
    {{ message }}
  </div>
</transition>
  </template>
<script>
import { toastBus } from './toast'

export default {
  data () {
    return {
      message: '',
      type: 'info', // info | success | error | warning
      visible: false,
      timeoutId: null
    }
  },
  created () {
    toastBus.$on('show-toast', this.showToast)
  },
  methods: {
    showToast ({ message, type = 'info', duration = 3000 }) {
      this.message = message
      this.type = type
      this.visible = true

      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(this.removeToast, duration)
    },
    removeToast () {
      this.visible = false
    }
  },
  beforeDestroy () {
    toastBus.$off('show-toast', this.showToast)
  }
}
</script>

  <style scoped>
  .toast {
    position: fixed;
    top: 2%;
    right: 1%;
    z-index: 9999999;
    padding: 12px 20px;
    border-radius: 5px !important;
    color: white;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
  .toast.info {
    background-color: #2196f3;
  }
  .toast.success {
    background-color: #4caf50;
  }
  .toast.error {
    background-color: #f44336;
  }
  .toast.warning {
    background-color: #ff9800;
  }
  .toast-enter-active {
  animation: slide-in 0.4s ease-out forwards;
}

.toast-leave-active {
  animation: slide-out 0.4s ease-in forwards;
}

@keyframes slide-in {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-50%);
    opacity: 0;
  }
}
  </style>
